jQuery(document).ready(function ($) {
    $('.top-slider').slick({
        infinite: true,
        autoplay: true,
        autoplaySpeed: 10000,
        slidesToShow: 1,
        slidesToScroll: 1,
        'arrows': false
    });

    $('.middle-slider').slick({
        infinite: true,
        autoplay: true,
        autoplaySpeed: 10000,
        slidesToShow: 1,
        slidesToScroll: 1,
        'arrows': false
    });
})
